<template>
  <div>
    <div class="columns">
      <div v-if="canActivate" class="column is-one-quarter">
        <b-button type="is-light" size="is-medium" expanded @click="$emit('activate:client')">Activate Client</b-button>
      </div>
      <div v-if="canDeactivate" class="column is-one-quarter">
        <b-button type="is-light" size="is-medium" expanded @click="$emit('suspend:client')">Deactivate Client</b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    canEdit () {
      return true
    },
    canActivate () {
      return (this.client.suspended_at !== null)
    },
    canDeactivate () {
      return (this.client.status === 'active' && this.client.suspended_at === null)
    }
  },
  props: {
    client: {
      type: Object,
      required: true
    }
  }
}
</script>
